/** How much later, in rows, each column further from the + starts. */
const COLUMN_DELAY = 0.35;

/**
 * Entrance order of a grid cell for the + menu's stagger: its distance from
 * the grid's bottom-right corner (the side of the + button), counted in rows,
 * with columns further left starting a little later. The first cell to
 * appear is the bottom-right one, at 0.
 */
export const staggerOrder = (
  index: number,
  columns: number,
  count: number,
): number => {
  const rowCount = Math.ceil(count / columns);
  const row = Math.floor(index / columns);
  const column = index % columns;
  const columnsInRow = Math.min(columns, count - row * columns);
  const rowFromBottom = rowCount - 1 - row;
  const columnFromRight = columnsInRow - 1 - column;
  return rowFromBottom + columnFromRight * COLUMN_DELAY;
};
